module.exports = __webpack_public_path__ + "img/empty-development.5454d405.svg";